import { Bot } from "../bot/types";
import { getVoices } from "./voices";

export const LANGUAGES = [
  "English",
  "Spanish",
  "French",
  "German",
  "Italian",
  "Dutch",
  "Portuguese",
  "Japanese",
  "Chinese",
  "Korean",
  "Russian",
  "Arabic",
  "Greek",
  "Ukrainian",
  "Polish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Swedish",
  "Indonesian",
] as const;

export const BOT_GENDERS = ["Male", "Female", "Non-binary"] as const;

export const BOTS: Bot[] = [
  {
    id: "c65b2ef0-2ce9-447c-a850-c79a52bfadb8",
    name: "When I'm confident in english I will …",
    subtitle:
      "Complète cette phrase et dis à l'IA tout ce que tu feras quand tu parleras anglais avec confiance",
    avatar: "01",
    language: "English",
    gender: "Male",
    voice: getVoices("English", "Male")[0],
  },
  {
    id: "42372495-17d9-49b9-92cb-1f145967f5f5",
    name: "Today, I …",
    subtitle:
      "Raconte à notre petit robot ce que tu as fait aujourd'hui, ce weekend, ou ce mois-ci !",
    avatar: "11",
    language: "English",
    gender: "Female",
    voice: getVoices("English", "Female")[0],
  },
  {
    id: "7b54c5be-abb7-44bc-85ed-422f7d2d818b",
    name: "I work in …",
    subtitle:
      "Texte Dis à notre petit robot quelle est ton occupation, profession, ou ce que tu étudies et tu verras il aura sûrement des questions à te poser.",
    avatar: "13",
    language: "English",
    gender: "Male",
    voice: getVoices("English", "Male")[1],
  },
];

export const PROFESSIONAL_BOTS: Bot[] = [
  {
    id: "pro-interview-coach",
    name: "Interview Coach",
    subtitle:
      "Préparez-vous aux entretiens d'embauche en anglais avec des simulations réalistes et des retours constructifs",
    avatar: "14", // Professional looking avatar
    language: "English",
    gender: "Female",
    voice: getVoices("English", "Female")[0],
  },
  {
    id: "pro-business-tutor",
    name: "Business English Tutor",
    subtitle:
      "Améliorez votre anglais professionnel avec un tuteur qui vous guide à travers des situations de travail courantes",
    avatar: "15", // Professional looking avatar
    language: "English",
    gender: "Male",
    voice: getVoices("English", "Male")[0],
  },
];
